var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"value":_vm.value,"options":_vm.options,"placeholder":_vm.placeholder,"loading":false},on:{"input":_vm.onSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }